import { useState, useRef } from "react";
import classNames from "classnames";
import { SmallLoader } from "../../components/utilities/loader";
import { AppAlert } from "../../components/utilities/app-alert";
import { useAuth } from "../../services/authentication/authentication.context";

import "../../styles/home.css";
import "../../styles/aichat.css";
import { AppHeader } from "../../components/header/header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, height } from "@fortawesome/free-regular-svg-icons/faPaperPlane";


export const AiChatPage = () => {

    const [message, setMessage] = useState('');
    const [onAlert, setOnAlert] = useState();
    const [aiResp, setAiresp] = useState('');
    const [chatMessages, setChatMessages] = useState([]);

    const { isLoading, chatWithAI, token } = useAuth();

    const mathRef = useRef();
    const testRef = useRef();

    const slowTypeText = (input) => {
        let i = 0;

        const intervalId = setInterval(() => {
            setAiresp(input.slice(0, i));

            i++;

            if (i > input.length) {
                clearInterval(intervalId);

            }
        }, 20);
    }

    const handleSubmit = async () => {
        if (!message || message === undefined || message === "") {
            setOnAlert({
                message: 'Say something at least',
                caption: 'Empty prompt',
                onAccept: () => setOnAlert(),
                accept: "OK",
                closeAlert: () => setOnAlert()
            });
            return;
        }
        scrolltoBottom();
        const resp = await chatWithAI({ content: message }, token);
        slowTypeText(resp?.message);
        setChatMessages((chMsgs) => ([...chMsgs, { msg: message, resp: resp?.message }]));
    }

    const scrolltoBottom = () => {
        if (testRef.current) {
            testRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    return (
        <div>
            <AppHeader />
            <div className={classNames("flx-cnt-pg")}>
                {onAlert &&
                    <AppAlert
                        caption={onAlert.caption}
                        message={onAlert.message}
                        accept={onAlert.accept}
                        onAccept={onAlert.action}
                        closeAlert={() => setOnAlert()}
                    />
                }
                <div className={classNames("cap", "lg-txt")}>Send an AI prompt</div>
                <div className="sm-sp" />
                <div className="ai-form">
                    <div className="resp-section">
                        {chatMessages?.map((chMsg, k) =>
                        (<>
                            <pre className={classNames("resp-data", "req-txt")}>{chMsg.msg.trim()}</pre>
                            <pre 
                                className={classNames("resp-data", "res-txt")}
                                ref={mathRef}
                            >
                                {k === (chatMessages.length - 1) ?
                                    aiResp : chMsg?.resp
                                }
                            </pre>

                        </>)
                        )}
                        {isLoading && <SmallLoader />}
                    </div>
                    <div className="chat-input">
                        <div
                            className="chat-input-box"
                            contentEditable
                            onBlur={(e) => setMessage(e.currentTarget.innerText)}
                            dangerouslySetInnerHTML={{ __html: message }}
                        />


                        <button
                            className="chat-send"
                            onClick={() => {
                                handleSubmit();
                                setMessage('');
                            }}
                        >
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                    </div>

                </div>
                <div ref={testRef}>{" "}</div>
            </div>
        </div>
    )
}